import { useMediaQuery, useTheme } from '@mui/material';

export const LABELS_DESKTOP_MIN_WIDTH_PX = 900;

export function isLabelsDesktopViewport(widthPx: number): boolean {
  return Number.isFinite(widthPx) && widthPx >= LABELS_DESKTOP_MIN_WIDTH_PX;
}

export function useLabelsDesktopViewport(): boolean {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.up('md'));
}
